import { trackErrorEvents } from "@utils/googleAnalytics/googleAnalyticsEvents";

export function getFileData(url: string) {
  return {
    send: async () => {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to fetch file: ${response.statusText}`);
        }
        const blob = await response.blob();
        return blob;
      } catch (err: any) {
        trackErrorEvents({
          type: 'get_file_data_fetch_failed',
          errorStack: err,
        },);
        throw new Error(`Error fetching file: ${err.message}`);
      }
    },
  };
}
